











import { Component, Prop, Vue } from "vue-property-decorator";

import NowPageTriangle from "./resources/notNowPageTriangle.vue";

const TRIANGLE_WIDTH = 24;

@Component({
    components: {
        NowPageTriangle
    }
})
export default class Tab extends Vue 
{
    @Prop() private tab!: { id : number, link : string, name : string, isSelected : boolean };
    @Prop() private tabCount!: number;
    @Prop() private tabIndex!: number;

    get isFirstChild(): boolean
    {
        return this.tabIndex === 0;
    }

   get  isLastChild(): boolean
    {
        return this.tabIndex === this.tabCount - 1;
    }

    get width(): string
    {
        const basis = `(100% - ${TRIANGLE_WIDTH}px * ${this.tabCount - 1}) / ${this.tabCount}`
        if (this.isFirstChild || this.isLastChild)
        {
            return `calc(${basis} + ${TRIANGLE_WIDTH}px)`;
        }
        return `calc(${basis} + ${TRIANGLE_WIDTH * 2}px)`;
    }

    get labelWidth(): string
    {
        if (this.isLastChild)
        {
            return '100%';
        }
        // 隙間がちらつくので少し長めにする
        return `calc(100% - ${TRIANGLE_WIDTH - 2}px)`;
    }

    get left(): string
    {
        return `-${this.tabIndex * TRIANGLE_WIDTH}px`;
    }

    get tabStyle()
    {
        return {
            display: 'inline-flex',
            position: 'relative',
            overflow: 'hidden',
            left: this.left,
            top: '0',
            width: this.width,
            height: '33px',
            zIndex: this.tabCount - this.tabIndex + 5,
        };
    }

    get color(): string
    {
        if (this.tab.isSelected)
        {
            return this.$store.getters.userConfigColors.darkButtonColorCode;
        }
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    get cursor(): string
    {
        if (this.tab.isSelected)
        {
            return 'default';
        }
        return 'pointer';
    }

    click()
    {
        if (this.tab.isSelected)
        {
            return;
        }
        this.$emit('click', this.tab.id);
    }
}
